(function() {
  var STORAGE_KEY = 'wishlist_items_v1';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      return [];
    } catch (e) {
      console.warn('Wishlist parse error', e);
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      console.warn('Wishlist save error', e);
    }
  }

  function isInWishlist(handle) {
    var list = getWishlist();
    return list.indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index !== -1) {
      list.splice(index, 1);
      saveWishlist(list);
    }
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  }

 function updateButtonState(button) {
  if (!button) return;

  const handle = button.dataset.productHandle;
  const img = button.querySelector(".wishlist-icon");

  const inactive = button.dataset.iconInactive;
  const active = button.dataset.iconActive;

  const isActive = isInWishlist(handle);

  button.classList.toggle("is-active", isActive);
  button.setAttribute("aria-pressed", isActive ? "true" : "false");

  if (img) {
    img.src = isActive ? active : inactive;
  }
}


  function updateAllButtons() {
    var buttons = document.querySelectorAll('.wishlist-toggle[data-product-handle]');
    buttons.forEach(updateButtonState);
  }

  function updateWishlistCount() {
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    var count = getWishlist().length;
    countEls.forEach(function(el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  // ===== Money format from theme =====
  var moneyFormat = (typeof window.themeMoneyFormat === 'string' && window.themeMoneyFormat.length)
    ? window.themeMoneyFormat
    : '{{ amount }}';

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = parseInt(cents, 10) || 0;

    var value = (cents / 100).toFixed(2);

    // handle {{ amount }} and {{ amount_no_decimals }}
    var formatted = moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, value);

    return formatted;
  }

  // ===== Drawer logic =====
  var drawer, drawerList, drawerEmpty;

  function initDrawerRefs() {
    drawer = document.getElementById('WishlistDrawer');
    drawerList = document.getElementById('WishlistDrawerList');
    drawerEmpty = document.getElementById('WishlistDrawerEmpty');
  }

  function isDrawerOpen() {
    return drawer && drawer.classList.contains('is-open');
  }

  function openDrawer() {
    if (!drawer) return;
    renderWishlistDrawer();
    drawer.classList.add('is-open');
    document.documentElement.classList.add('wishlist-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('wishlist-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function createDrawerItem(product) {
    var item = document.createElement('div');
    item.className = 'wishlist-drawer__item';

    var link = document.createElement('a');
    link.href = product.url;
    link.className = 'wishlist-drawer__thumb';

    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title;
      img.loading = 'lazy';
      link.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'wishlist-drawer__info';

    var titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.className = 'wishlist-drawer__title';
    titleLink.textContent = product.title;

    var price = document.createElement('div');
    price.className = 'wishlist-drawer__price';
    price.textContent = formatMoney(product.price);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-toggle';
    btn.setAttribute('data-product-handle', product.handle);
    btn.setAttribute('aria-pressed', 'true');

    var icon = document.createElement('span');
    icon.className = 'wishlist-toggle__icon';
    icon.textContent = '♥';

    var text = document.createElement('span');
    text.className = 'wishlist-toggle__text';
    text.textContent = 'Remove from wishlist';

    btn.appendChild(icon);
    btn.appendChild(text);

    info.appendChild(titleLink);
    info.appendChild(price);
    info.appendChild(btn);

    item.appendChild(link);
    item.appendChild(info);

    return item;
  }

  function renderWishlistDrawer() {
    if (!drawerList || !drawerEmpty) return;

    drawerList.innerHTML = '';
    var handles = getWishlist();

    if (!handles.length) {
      drawerEmpty.style.display = 'block';
      return;
    }

    drawerEmpty.style.display = 'none';

    handles.forEach(function(handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(res) { return res.json(); })
        .then(function(product) {
          var item = createDrawerItem(product);
          drawerList.appendChild(item);
        })
        .catch(function(err) {
          console.error('Error loading wishlist product in drawer', handle, err);
        });
    });
  }

  function bindEvents() {
    document.addEventListener('click', function(event) {
      // wishlist buttons (cards, product page, drawer)
      var btn = event.target.closest('.wishlist-toggle[data-product-handle]');
      if (btn) {
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;

        toggleWishlist(handle);
        updateButtonState(btn);
        updateWishlistCount();

        if (isDrawerOpen()) {
          renderWishlistDrawer();
        }
        return;
      }

      // open drawer from header icon
      var openTrigger = event.target.closest('[data-wishlist-open]');
      if (openTrigger) {
        event.preventDefault(); // stop navigation to the page
        openDrawer();
        return;
      }

      // close drawer
      var closeTrigger = event.target.closest('[data-wishlist-close]');
      if (closeTrigger) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && isDrawerOpen()) {
        closeDrawer();
      }
    });

    document.addEventListener('shopify:section:load', function() {
      updateAllButtons();
      updateWishlistCount();
      initDrawerRefs(); // header might reload in editor
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initDrawerRefs();
    bindEvents();
    updateAllButtons();
    updateWishlistCount();
  });

  // expose API for wishlist page script
  window.WishlistStore = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist
  };
})();
